const path1 = document.getElementById("pathway-1-line-1");
const path2 = document.getElementById("pathway-1-line-2");
const path1Mobile = document.getElementById("pathway-1-line-1-mobile");
const path2Mobile = document.getElementById("pathway-1-line-2-mobile");

const path1Length = 580;
const path2Length = 1015;
const path1MobileLength = 585;
const path2MobileLength = 920;

path1.style.strokeDasharray = Math.round(path1Length);
path1.style.strokeDashoffset = Math.round(path1Length);

path2.style.strokeDasharray = Math.round(path2Length);
path2.style.strokeDashoffset = Math.round(path2Length);

path1Mobile.style.strokeDasharray = Math.round(path1MobileLength);
path1Mobile.style.strokeDashoffset = Math.round(path1MobileLength);

path2Mobile.style.strokeDasharray = Math.round(path2MobileLength);
path2Mobile.style.strokeDashoffset = Math.round(path2MobileLength);

window.addEventListener("scroll", function(){
    pathScroll(path1, path1Length, 50, 1 );
    pathScrollNegative(path2, path2Length, 100, 1.2 );
    pathScrollNegative(path1Mobile, path1MobileLength, 200, 1.2 );
    pathScroll(path2Mobile, path2MobileLength, 200, 1.2 );
});

function pathScroll( path, pathLength, offset = 0, speed ) {
    const pathHeight = path.getBoundingClientRect().height;
    const endTrigger = path.getBoundingClientRect().bottom - document.documentElement.clientHeight;
    const startTrigger = endTrigger - pathHeight + offset;
    const scrollPercent = Math.abs(startTrigger) / pathHeight;
    const dashOffset = Math.round(pathLength - ( pathLength * scrollPercent / speed ));
  
    if( startTrigger < 0 ) {
        if( dashOffset >= 0 && dashOffset <= pathLength ) {
            path.style.strokeDashoffset = dashOffset;
            path.style.transitionDuration = "0.2s";
        } else {
            path.style.strokeDashoffset = 0;
            path.style.transitionDuration = "0.4s";
        }
    } else {
        path.style.strokeDashoffset = pathLength;
        path.style.transitionDuration = "0.4s";
    }
}

function pathScrollNegative( path, pathLength, offset = 0, speed ) {
    const pathHeight = path.getBoundingClientRect().height;
    const endTrigger = path.getBoundingClientRect().bottom - document.documentElement.clientHeight;
    const startTrigger = endTrigger - pathHeight + offset;
    const scrollPercent = Math.abs(startTrigger) / pathHeight;
    const dashOffset = Math.round(pathLength + ( pathLength * scrollPercent / speed ));
    const animationEnd = pathLength * 2;
  
    if( startTrigger < 0 ) {
        if( dashOffset <= animationEnd && dashOffset >= pathLength ) {
            path.style.strokeDashoffset = dashOffset;
            path.style.transitionDuration = "0.2s";
        } else {
            path.style.strokeDashoffset = animationEnd;
            path.style.transitionDuration = "0.4s";
        }
    } else {
        path.style.strokeDashoffset = pathLength;
        path.style.transitionDuration = "0.4s";
    }
}
